import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.293 12.293a1 1 0 0 1 1.414 0L18 16.586l4.293-4.293a1 1 0 0 1 1.414 1.414L19.414 18l4.293 4.293a1 1 0 0 1-1.414 1.414L18 19.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L16.586 18l-4.293-4.293a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }